// P96 — CP Marketing → Newsletters: the words the page shows (the CP is in English) and how it reads its address.

export const LISTS = [
  ["sportya", "Sportya (players · tennis & padel)"],
  ["tenis10", "Tenis10 (parents)"],
]
export const TYPES = [["all", "All"], ["account", "Accounts"], ["guest", "Email only"]]
export const SOURCES = {
  site_form: ["Site form", "warning"],
  sign_up: ["Sign-up", "primary"],
  settings: ["Settings", "secondary"],
  resubscribed: ["Resubscribed", "info"],
  unknown: ["Before audit", "light"],
  unsubscribe: ["Unsubscribed", "light"],
}
export const SOURCE_FILTERS = [["", "All sources"], ["site_form", "Site form"], ["sign_up", "Sign-up"], ["settings", "Settings"],
  ["resubscribed", "Resubscribed"], ["unknown", "Before audit"]]
export const SPORTS = [["", "All sports"], ["tennis", "Tennis"], ["padel", "Padel"]]
export const STATUSES = [["subscribed", "Subscribed"], ["unsubscribed", "Unsubscribed"]]
export const REGIONS = [["", "All regions"], ["moldova", "Moldova"], ["dobrogea", "Dobrogea"], ["bucuresti", "București"],
  ["oltenia", "Oltenia"], ["banat", "Banat"], ["transilvania-nord", "Transilvania Nord"], ["cluj", "Cluj"],
  ["transilvania-sud", "Transilvania Sud"], ["muntenia", "Muntenia"], ["bulgaria", "Bulgaria"]]
export const regionLabel = id => REGIONS.find(([key]) => key === id)?.[1] || id || "—"
export const PAGES = { homepage: "Homepage", tenis10: "Tenis10 page" }

const ERRORS = {
  SUPER_ADMIN_REQUIRED: "Only a super admin opens Marketing.",
  INVALID_NEWSLETTER_SUBSCRIBERS_FILTER: "A filter isn't valid. Check the search (3 characters at least) and the dates.",
  NEWSLETTER_GUEST_NOT_FOUND: "This subscriber is no longer here (unsubscribed, deleted or now an account). Reload the list.",
}
export const errorText = (error, fallback) => ERRORS[error?.response?.data?.message] || fallback

export const formatDate = value => {
  if (!value) return "—"
  const date = new Date(value)
  return Number.isNaN(date.getTime()) ? "—" : date.toLocaleDateString("ro-RO", { day: "2-digit", month: "2-digit", year: "numeric" })
}
export const formatDateTime = value => {
  if (!value) return "—"
  const date = new Date(value)
  return Number.isNaN(date.getTime()) ? "—"
    : `${formatDate(value)} ${date.toLocaleTimeString("ro-RO", { hour: "2-digit", minute: "2-digit" })}`
}
export const formatCount = value => (Number.isFinite(value) ? value.toLocaleString("ro-RO") : "…")

const DATE = /^\d{4}-\d{2}-\d{2}$/
const choice = (value, values, fallback) => (values.some(([key]) => key === value) ? value : fallback)

/** The page's state from the address: list, type, filters and page. */
export const readNewsletterQuery = search => {
  const params = new URLSearchParams(search)
  const page = Number(params.get("page"))
  return {
    list: choice(params.get("list"), LISTS, "sportya"),
    type: choice(params.get("type"), TYPES, "all"),
    status: choice(params.get("status"), STATUSES, "subscribed"),
    sport: choice(params.get("sport") || "", SPORTS, ""),
    regionId: choice(params.get("regionId") || "", REGIONS, ""),
    source: choice(params.get("source") || "", SOURCE_FILTERS, ""),
    from: DATE.test(params.get("from") || "") ? params.get("from") : "",
    to: DATE.test(params.get("to") || "") ? params.get("to") : "",
    q: (params.get("q") || "").slice(0, 100),
    page: Number.isInteger(page) && page > 0 && page <= 100000 ? page : 1,
  }
}
export const writeNewsletterQuery = state => {
  const params = new URLSearchParams()
  if (state.list !== "sportya") params.set("list", state.list)
  ;[["type", "all"], ["status", "subscribed"], ["sport", ""], ["regionId", ""], ["source", ""], ["from", ""], ["to", ""], ["q", ""]]
    .forEach(([key, fallback]) => { if (state[key] && state[key] !== fallback) params.set(key, state[key]) })
  if (state.page > 1) params.set("page", String(state.page))
  return params.toString() ? `?${params}` : ""
}

/** The API's filters for the page's state (the dates as whole days; `to` includes its day). */
export const apiFilters = (state, limit) => {
  const nextDay = day => new Date(new Date(`${day}T00:00:00Z`).getTime() + 86400000).toISOString()
  return {
    list: state.list,
    type: state.type,
    status: state.status,
    sport: state.sport,
    regionId: state.regionId,
    source: state.status === "subscribed" ? state.source : "",
    from: state.from ? `${state.from}T00:00:00.000Z` : "",
    to: state.to ? nextDay(state.to) : "",
    q: state.q.trim().length >= 3 ? state.q.trim() : "",
    page: state.page,
    limit,
  }
}
